<template>
<div @keydown.esc.prevent="$emit('changeVisibility')" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div @click="$emit('changeVisibility')" class="fixed inset-0 bg-gray-700 bg-opacity-60 transition-opacity" aria-hidden="true"></div>

    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom dark:bg-gray-800 bg-gray-50 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-3/4">
      <div class="dark:bg-gray-900 bg-gray-50 px-4 pt-5 pb-4 sm:p-6 sm:pb-4 group">
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-2xl leading-6 font-medium dark:text-gray-300 text-gray-900" id="modal-title">
              {{type === 'adesao' ? 'Confirmação de adesão à pesquisa' : 'Confirmação da pesquisa'}}
            </h3>
            <div class="mt-4 dark:text-gray-300 flex flex-col gap-x-4 gap-y-4 flex-wrap">
                <div class="flex flex-row gap-y-4 w-full justify-between">
                    <span class="w-1/2 ">
                        <p class="text-lg dark:text-indigo-400 text-indigo-600 truncate">{{loja.razao_social}}</p>
                        <p class="text dark:text-indigo-200 text-indigo-400">{{loja.nome_fantasia}}</p>
                        <p class="text-sm dark:text-gray-200 text-gray-600">{{cnpjMask(loja.cnpj)}}</p>
                        <p class="text-sm dark:text-gray-300 text-gray-500">{{loja.telefone1 ? phoneMask(loja.telefone1) : phoneMask(loja.telefone2)}} - {{loja.responsavel ? loja.responsavel : 'Sem informação do nome'}}</p>
                    </span>
                </div>
                <div class="flex-1 flex flex-col w-4/5 space-y-6 mx-auto">
                    <div>
                        <p class="w-full text-sm font-bold mb-1.5">Selecione o mês de referência</p>
                        <div :class="anomesDatepicker === '' ? 'opacity-100' : 'opacity-40'" class="flex space-x-4 transition-all duration-500">
                            <button @click="setAnoMes('passado')" :class="selectAnoMes === 'passado' ? 'bg-indigo-500 text-gray-100 border-transparent' : 'border-gray-300 dark:border-gray-600 text-indigo-500'" class="border w-full h-auto rounded-lg flex items-center justify-evenly p-4 transition-all duration-500" :disabled="anomesDatepicker !== ''">
                                <span class="material-icons-outlined text-4xl">
                                    calendar_month
                                </span>
                                <span class="flex flex-col">
                                    <p :class="selectAnoMes === 'passado' ? 'text-gray-100' : 'text-gray-400'" class="text-xs uppercase">Mês Passado</p>
                                    <p>{{months[pastAnoMes.getMonth()]}}/{{pastAnoMes.getFullYear()}}</p>
                                </span>
                            </button>
                            <button @click="setAnoMes('corrente')" :class="selectAnoMes === 'corrente' ? 'bg-indigo-500 text-gray-100 border-transparent' : 'border-gray-300 dark:border-gray-600 text-indigo-500'" class="border w-full h-auto rounded-lg flex items-center justify-evenly p-4 transition-all duration-500" :disabled="anomesDatepicker !== ''">
                                <span class="material-icons-outlined text-4xl">
                                    calendar_month
                                </span>
                                <span class="flex flex-col">
                                    <p :class="selectAnoMes === 'corrente' ? 'text-gray-100' : 'text-gray-400'" class="text-xs uppercase transition-all duration-300">Mês Corrente</p>
                                    <p>{{months[date.getMonth()]}}/{{date.getFullYear()}}</p>
                                </span>
                            </button>
                        </div>
                        <div v-if="userRole === 'administrador'" class="transition-all duration-500" :class="!anomes ? 'opacity-100' : 'opacity-40'" >
                            <p class="w-full text-sm mt-3 mb-4 text-center">ou selecione um período específico</p>
                            <Datepicker v-model="anomesDatepicker" :disabled="anomes !== ''"/>
                        </div>

                    </div>
                    <p class="font-bold text-sm">Informações do contato</p>
                    <span class="flex gap-x-4">
                        <div class="w-full flex flex-row flex-wrap space-x-2">
                            <div class="flex-1">
                                <Select v-model="status" label="Status" placeholder="Selecionar status" :list="statusList" desc="descricao"/>
                            </div>
                            <transition name="fade">
                                <button v-if="status" @click="checkStatus = !checkStatus" :class="status === '' ? 'cursor-not-allowed ' : checkStatus ? 'bg-indigo-500 border-indigo-500' : 'border-gray-500'" class="w-12 h-10 border rounded-md transition-all duration-300 flex items-center justify-center" :disabled="status === ''">
                                    <span :class="checkStatus ? 'text-gray-100' : 'text-gray-500'" class="material-icons-outlined transition-all duration-300">
                                        check
                                    </span>
                                </button>
                            </transition>
                            <transition name="fade">
                                <p v-if="status && !checkStatus" class="w-full text-xs text-red-500 mt-1">Confirme o status</p>
                            </transition>
                        </div>
                        <Input v-model="nome_contato" label="Nome do Atendente"/>
                    </span>
                    <TextArea class="h-16" v-model="obs" label="Observações"/>
                </div>
                <div class="w-full max-h-72 overflow-y-scroll overflow-x-hidden px-1">
                    <Table :headers="['pesquisador', 'nome_contato_loja', 'ano_mes', 'data', 'status_descricao', 'observacao']" :data="historico"/>
                </div>
            </div>
          </div>
      </div>
      <div class=" dark:bg-gray-900 bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button @click="saveLoading = true; verificarNovoStatus(loja.cnpj)" type="button" class="btn w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" :disabled="saveLoading || status === '' || (anomes === '' && anomesDatepicker === '') || !checkStatus">
            <span v-if="saveLoading" class="w-auto h-full">
                <Spinner width="4"/>
            </span>
          <span v-else>Salvar {{status === 'OK Cadastrado' ? 'e Iniciar Pesquisa' : ''}}</span>
        </button>
        <button @click="$emit('changeVisibility')" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Cancelar
        </button>
        <span v-if="userRole === 'administrador' && type !== 'adesao' && historico[0]" class="flex text-gray-100 w-full h-full ">
            <button @click="clickRevert()" :class=" !revertButton? 'rounded-lg w-32' : 'rounded-l-lg w-24' " class="btn w-12 text-sm bg-transparent bg-indigo-500 hover:bg-indigo-400 h-10 transition-all duration-300" :disabled="revertLoading || parseInt(historico[0].status_id) === 12 ||  historico.length < 2">
                {{!revertButton ? 'Reverter Status' : 'Cancelar'}}
            </button>
            <transition name="slide">
                <button @click="confirmRevert()" v-if="revertButton" class="text-sm bg-indigo-600 rounded-r-lg h-10 hover:bg-indigo-700 transition-all duration-300" >
                    <div class="px-4 flex flex-row space-x-4 items-center">
                        <div> Confirmar Reverter</div>
                        <div class="">{{timeLeft}}</div>
                    </div>
                </button>
            </transition>
        </span>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { POST_HISTORICO_CONTATOS_ATIVAS, POST_HISTORICO_CONTATOS_ADESAO, ADESAO_TO_ATIVA, GET_STATUS_CONTATO_ATIVAS, GET_STATUS_CONTATO_ADESAO, GET_HISTORICO_CONTATOS_ADESAO, GET_HISTORICO_CONTATOS_ATIVAS, REVERT_HISTORICO_CONTATOS_ATIVA, REVERT_HISTORICO_CONTATOS_ADESAO, VERIFICAR_STATUS_ANOMES } from '../../mixins/api'
import { displayNotification } from '../../mixins/notification'
import { telephoneMask, cnpjMask as cnpj_mask } from '../../mixins/mask.js'
import TextArea from '../Design/TextArea.vue'
import Select from '../Design/Select.vue'
import Datepicker from '../Design/Datepicker.vue'
import Input from '../Design/Input.vue'
import Table from '../Design/Table.vue'
import { computed, ref } from '@vue/reactivity'
import { useRouter } from 'vue-router'
import { findId } from '../../mixins/findData'
import { onMounted, watch } from '@vue/runtime-core'
import { getStatusColor as getColor } from '../../mixins/colors'
import { useStore } from 'vuex'
import Spinner from '../Design/Spinner.vue'

export default {
    name: 'FileModal',
    components: {
        TextArea,
        Select,
        Input,
        Table,
        Datepicker,
        Spinner
    },
    props: ['loja', 'type'],
    setup (props, { emit }) {
        const store = useStore()
        const userRole = store.getters['auth/user'].role

        const phoneMask = telephoneMask
        const cnpjMask = cnpj_mask
        const router = useRouter()

        const obs = ref('')
        const nome_contato = ref('')
        const statusList = ref([])
        const status = ref('')
        const checkStatus = ref(false)
        const historico = ref({})

        const revertButton = ref(0)
        const maxTimer = ref(10)
        const timePassed = ref(0)
        const timerInterval = ref(null)
        const timeLeft = computed(() => {
            return maxTimer.value - timePassed.value
        })

        let REVERT_FUNCTION = null
        const revertLoading = ref(false)
        const confirmRevert = async () => {
            const reference = props.type === 'adesao' ? props.loja.cnpj : props.loja.id
            revertLoading.value = true
            await REVERT_FUNCTION(reference).then(r => {
                displayNotification(r)
                getHistoricoData()
            }).catch(e => {
                displayNotification(e.response)
            })
            revertLoading.value = false
        }

        const clickRevert = () => {
            if (revertButton.value === 0) {
                startTimer()
                revertButton.value++
            } else {
                cleanInterval()
                revertButton.value = 0
                timePassed.value = 0
            }
        }

        const startTimer = () => {
            timerInterval.value = setInterval(() => (timePassed.value += 1), 1000)
        }
        
        watch(() => status.value, (n, o) => {
            if (n === '') {
                checkStatus.value = false
            }
        })

        watch(() => timeLeft.value, (n, o) => {
            if (n === 0) {
                cleanInterval()
                revertButton.value = 0
                timePassed.value = 0
            }
        })

        const cleanInterval = () => {
            clearInterval(timerInterval.value)
        }

        const months = [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro'
        ]
        const anomesDatepicker = ref('')
        const anomes = ref('')
        const date = new Date()

        const pastAnoMes = new Date(date.getFullYear(), date.getMonth(), date.getDay())
        pastAnoMes.setMonth(date.getMonth() - 1)

        const selectAnoMes = ref('')

        const setAnoMes = (mesReferencia) => {
            selectAnoMes.value = mesReferencia
            if (mesReferencia === 'corrente') {
                anomes.value = date.getFullYear() + '' + (date.getMonth() + 1 <= 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
            } else if (mesReferencia === 'passado') {
                anomes.value = pastAnoMes.getFullYear() + '' + (pastAnoMes.getMonth() + 1 <= 9 ? '0' + (pastAnoMes.getMonth() + 1) : pastAnoMes.getMonth() + 1)
            }
        }

        let POST_FUNCTION = null

        const getHistoricoData = () => {
            if (props.type === 'adesao') {
                GET_STATUS_CONTATO_ADESAO().then(r => {
                    statusList.value = r.data
                })
                GET_HISTORICO_CONTATOS_ADESAO(props.loja.cnpj).then(r => {
                    historico.value = r.data.data
                })
                POST_FUNCTION = POST_HISTORICO_CONTATOS_ADESAO
                REVERT_FUNCTION = REVERT_HISTORICO_CONTATOS_ADESAO
            } else {
                GET_STATUS_CONTATO_ATIVAS().then(r => {
                    statusList.value = r.data.filter(x => x.id !== 13 && x.id !== 14)
                })
                GET_HISTORICO_CONTATOS_ATIVAS(props.loja.id).then(r => {
                    historico.value = r.data.data
                })
                POST_FUNCTION = POST_HISTORICO_CONTATOS_ATIVAS
                REVERT_FUNCTION = REVERT_HISTORICO_CONTATOS_ATIVA
            }
        }

        onMounted(() => {
            getHistoricoData()
        })

        const getCurrentDate = () => {
            const date = new Date()
            return `${date.getFullYear()}-${(date.getMonth() + 1 <= 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)}-${(date.getDate() <= 9 ? '0' + date.getDate() : date.getDate())} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
        }

        const saveHistorico = async (cnpj, body) => {
            if (findId(statusList.value, status.value, 'descricao') === 6 || findId(statusList.value, status.value, 'descricao') === 12) {
                sessionStorage.setItem('historico', JSON.stringify({ ...body }))
                if (findId(statusList.value, status.value, 'descricao') === 6 && props.type === 'adesao') {
                    await ADESAO_TO_ATIVA({ cnpj: cnpj, ano_mes: body.ano_mes }).then(r => {
                        router.push({ name: 'Pesquisa', params: { cnpj: cnpj.toString() } })
                    })
                } else {
                    router.push({ name: 'Pesquisa', params: { cnpj: cnpj.toString() } })
                }
            } else {
                await POST_FUNCTION(body).then(r => {
                    displayNotification(r)
                    emit('changeAndReload')
                }).catch(e => {
                    displayNotification(e.response)
                })
            }
        }

        const saveLoading = ref(false)
        const verificarNovoStatus = async (cnpj) => {
            saveLoading.value = true
            const body = {
                cnpj: cnpj,
                ano_mes: anomes.value === '' ? anomesDatepicker.value : anomes.value,
                status_id: findId(statusList.value, status.value, 'descricao'),
                data: getCurrentDate(),
                observacao: obs.value,
                pesquisador_id: 3,
                nome_contato_loja: nome_contato.value,
                loja_id: props.type === 'ativas' ? props.loja.id : null

            }
            if (props.type === 'adesao') {
                await saveHistorico(cnpj, body)
            } else {
                await VERIFICAR_STATUS_ANOMES(body.loja_id, body.status_id, body.ano_mes).then(async r => {
                    await saveHistorico(cnpj, body)
                }).catch(e => {
                    displayNotification(e.response)
                })
            }
            saveLoading.value = false
        }

        const getStatusColor = getColor
        return {
            userRole,
            anomes,
            anomesDatepicker,
            obs,
            nome_contato,
            status,
            statusList,
            historico,
            phoneMask,
            cnpjMask,
            saveHistorico,
            selectAnoMes,
            setAnoMes,
            months,
            pastAnoMes,
            date,
            timeLeft,
            confirmRevert,
            clickRevert,
            revertButton,
            checkStatus,
            getStatusColor,
            revertLoading,
            verificarNovoStatus,
            saveLoading
        }
    }
}
</script>

<style scoped>

.fade-enter-from {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}

.fade-enter-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-from {
  opacity: 1;
}

.fade-leave-to {
  opacity: 0;
}

.slide-enter-from {
  opacity: 0;
    transform: translateX(-5%);
}
.slide-enter-to {
  opacity: 1;
    transform: translateX(0);
}

.slide-enter-active {
  transition: all 0.3s ease-in-out;
}

.slide-leave-active {
  transition: all 0.3s ease-in-out;
}

.slide-leave-from {
  opacity: 1;
    transform: translateX(0);
}

.slide-leave-to {
  opacity: 0;
    transform: translateX(-5%);
}


</style>
